import {
  ActionFunctionArgs,
  LoaderFunctionArgs,
  redirect,
} from "react-router-dom";
import { getAuth } from "firebase/auth";
import { getReadyAuthUser } from "~/utils/auth/waitForAuthReady";
import {
  getRouteWithParams,
  INTENTS,
  loadCookiesData,
  clearCookiesData,
} from "~/utils";
import { message } from "antd";
import { apiClient } from "~/services/apiClient";

export type CreateOrganizationLoaderType = {
  code?: string;
};

export async function CreateOrganizationLoader({
  request,
}: LoaderFunctionArgs): Promise<CreateOrganizationLoaderType> {
  const auth = getAuth();
  const user = await getReadyAuthUser();
  if (!user) redirect("/explore");

  const authAccessInfo = await loadCookiesData(user?.uid || "");
  if (!authAccessInfo.success) redirect("/explore");

  const url = new URL(request.url);
  const code = url.searchParams.get("code");

  return {
    code: code || undefined,
  };
}

export async function CreateOrganizationAction({
  request,
}: ActionFunctionArgs) {
  const auth = getAuth();
  const user = await getReadyAuthUser();
  const formData = await request.formData();
  const intent = formData.get("intent");
  switch (intent) {
    case INTENTS._create_organization: {
      const raw = JSON.parse(formData.get("body") as string) as {
        name?: string;
        transferProperties?: boolean;
      };
      const name = typeof raw.name === "string" ? raw.name.trim() : "";
      if (!name) {
        message.error("Name is required"); // TODO: Translate
        return {};
      }
      if (!user?.uid) {
        message.error("Not authenticated");
        return {};
      }

      const result = await apiClient.sendIntent<{ organizationID: string }>(
        INTENTS._create_organization,
        {
          name,
          transferProperties: Boolean(raw.transferProperties),
          userID: user.uid,
        }
      );

      if (!result.success) {
        message.error(result.error ?? "Failed to create organization"); // TODO: Translate
        return {};
      }

      clearCookiesData();
      const organizationID = result.data?.organizationID ?? "";
      return redirect(
        getRouteWithParams("organizationDetails", { organizationID })
      );
    }
    case INTENTS._request_organization: {
      const raw = JSON.parse(formData.get("body") as string) as {
        code?: string;
        requestTransferProperties?: boolean;
      };
      const code = typeof raw.code === "string" ? raw.code.trim() : "";
      if (!code) {
        message.error("Code is required"); // TODO: Translate
        return {};
      }
      if (!user?.uid) {
        message.error("Not authenticated");
        return {};
      }

      const result = await apiClient.sendIntent<{ organizationID: string }>(
        INTENTS._request_organization,
        {
          code,
          requestTransferProperties: Boolean(raw.requestTransferProperties),
          userID: user.uid,
        }
      );

      if (!result.success) {
        message.error(
          result.error ?? "Failed to add join organization request"
        ); // TODO: Translate
        return {};
      }
      message.success("Join organization request added"); // TODO: Translate
      return redirect(
        getRouteWithParams("organizationDetails", {
          organizationID: result.data?.organizationID ?? code,
        })
      );
    }
  }
  return {};
}
